import { useTheme } from '@simplywallst/ui-core';

import useWindowSize from '@/hooks/useWindowSize';

import { VisxText } from '@/components/VisxText';

interface Props {
  title: string;
}

const BuyLimit = ({ title }: Props) => {
  const theme = useTheme();
  const { width: screenWidth } = useWindowSize();
  return (
    <VisxText
      y={theme.x8spacePx}
      dy={theme.x3spacePx + 4}
      dx={theme.x1spacePx + 2}
      verticalAnchor="middle"
      width={
        screenWidth !== undefined && screenWidth <= theme.mdMaxRaw ? 160 : 400
      }
      lineHeight="1.5em"
      typography="xSmallStrong"
      fill={theme.color.chart01}
    >
      {title}
    </VisxText>
  );
};

export default BuyLimit;
